import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const URL_BASE_MONITOREO = BASE_URL;
const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const obtenerProyecto = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/proyecto/porUsuario`, obtenerConfig());
        // tranformar los datos
        const lstLista = response.data.map((item) => ({
            id: item.proyectoId,
            descripcion: item.sigla + ' - ' + item.nombre
        }));
        return lstLista;
    } catch (error) {
        console.error('Error al consultar Proyectos' + error.message);
        throw new Error('Error al consultar los Proyectos');
    }
};

export const obtenerProyectoAdm = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/proyecto`, obtenerConfig());
        // tranformar los datos
        const lstLista = response.data.map((item) => ({
            id: item.proyectoId,
            descripcion: item.sigla + ' - ' + item.nombre
        }));
        return lstLista;
    } catch (error) {
        console.error('Error al consultar Proyectos' + error.message);
        throw new Error('Error al consultar los Proyectos');
    }
};

export const obtenerPuesto = async (idProyecto) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/proyecto/${idProyecto}`, obtenerConfig());
        //console.log('losDatos: ', response.data);
        // transformar los datos
        const lstResponse = response.data.map((item) => ({
            id: item.puestoId,
            descripcion: item.sigla + ' - ' + item.nombre,
            codPuesto: item.codigo,
            telPuesto: item.telefonos,
            marcPuesto: item.codMarcaRapida,
            infoAdicional: item.infoAdicional
        }));
        return lstResponse;
    } catch (error) {
        console.error('Error al consultar Puesto' + error.message);
        throw new Error('Error al consultar los Proyectos');
    }
};

export const obtenerPuestoAdm = async (idProyecto) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/proyectoAdm/${idProyecto}`, obtenerConfig());
        //console.log('XX02=', response.data)
        // transformar los datos
        const lstResponse = response.data.map((item) => ({
            id: item.puestoId,
            descripcion: item.sigla + ' - ' + item.nombre,
            sigla: item.sigla
        }));
        //console.log('XX03', lstResponse)
        return lstResponse;
    } catch (error) {
        console.error('Error al consultar Puesto' + error.message);
        throw new Error('Error al consultar los Proyectos');
    }
};

export const obtenerEmpleado = async (idPuesto) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/turnotrabajo/puesto/${idPuesto}`, obtenerConfig());
        //console.log('KkK00-Datos:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error al obtener Empleados');
        throw new Error('Error al consultar');
    }
};

export const obtenerCodigos = async (idPersona) => {
    try {
        const response = axios.get(`${URL_BASE_MONITOREO}/personseguridad/${idPersona}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al obtener Datos de Seguridad');
        throw new Error('Error al consultar Datos de Seguridad');
    }
};

export const obtenerColores = async (idPersona) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/personseguridad/colores/${idPersona}`, obtenerConfig());
        //console.log('TT-Datos:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error al obtener colores Seguridad');
        throw new Error('Error al consultar Colores Seguridad');
    }
};

export const obtenerDatosSeguridad = async (idPersona) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/personseguridad/datos/${idPersona}`, obtenerConfig());
        //console.log ('XX01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al obtener colores Seguridad');
        throw new Error('Error al consultar Colores Seguridad');
    }
};

export const validarSeguridad = async (objDatosPer) => {
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/comunicaronda/valida`, objDatosPer, obtenerConfig());
        //console.log ('JjJj01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al Guardar datos Seguridad', error.message);
        throw new Error('Error al guardar datos de Seguridad');
    }
};

export const obtieneTurnosByPuestoFecha = async (puestoId, fechaVig) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/turnotrabajo/puestofecha/${puestoId}/${fechaVig}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al consultar fecha');
        throw new Error('Error al consultar Fecha');
    }
};

export const obtieneTodosEmpleados = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/persona/empleados`, obtenerConfig());
        //console.log('KK01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al consultar todos los Empleados');
        throw new Error('Error al consultar todos los Empleados');
    }
};

export const obtieneEmplePorProyecto = async (proyectoId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/persona/proyecto/${proyectoId}`, obtenerConfig());
        //console.log('KK01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al consultar Empleados por Proyecto');
        throw new Error('Error al consultar Empleados por Proyecto');
    }
};

export const obtenerEmplAsignados = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/empleadoAsignados`, obtenerConfig());
        //console.log('KK01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al consultar Empleados Asignados');
        throw new Error('Error al consultar Empleados Asignados');
    }
};

const fechaEnFormato = (fecha) => {
    let fechaTrabajo;
    if (fecha) {
        fechaTrabajo = fecha;
    } else {
        fechaTrabajo = new Date();
    }
    const anio = fechaTrabajo.getFullYear().toString();
    const mes = (fechaTrabajo.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0-11
    const dia = fechaTrabajo.getDate().toString().padStart(2, '0');
    const hora = fechaTrabajo.getHours().toString().padStart(2, '0');
    const minutos = fechaTrabajo.getMinutes().toString().padStart(2, '0');
    const segundos = fechaTrabajo.getSeconds().toString().padStart(2, '0');

    return `${anio}${mes}${dia}${hora}${minutos}${segundos}`;
};

export const descargaMonitorReporte = async (objData) => {
    //console.log('JJZ0:', objData)
    try {
        const objHeader = {
            ...obtenerConfig(),
            responseType: 'blob'
        };
        //const response = await axios.post(`${URL_BASE_MONITOREO}/reporteMonitor/pdf`, objData, objHeader);
        const response = await axios.post(`${URL_BASE_MONITOREO}/reporteMonitor/pdfResumen`, objData, objHeader);
        const pdfUrl = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `reporteMonitor${fechaEnFormato()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(pdfUrl);
    } catch (error) {
        console.error('Error al descargar PDF. ');
        console.error(`Error al descargar el reporte: ${error.response?.statusText || error.message}`);
    }
};

export const obtieneControlesPorHacer = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comunicaDetalle/horasCerca`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al consultar eventos Cercanos');
        throw new Error('Error al consultar eventos Cercanos');
    }
};

export const obtieneControlesPendientes = async () => {
    //console.log('ww000: ')
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/comunicaDetalle/horasPendientes`, obtenerConfig());
        //console.log('ww001: ', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al consultar eventos Pendientes');
        throw new Error('Error al consultar eventos Pendientes');
    }
};

export const obtieneDatosControl = async () => {
    //console.log('ZXZX00:')
    const resultadoParalelo = await Promise.allSettled([axios.get(`${URL_BASE_MONITOREO}/comunicaDetalle/horasCerca`, obtenerConfig()), axios.get(`${URL_BASE_MONITOREO}/comunicaDetalle/horasPendientes`, obtenerConfig())]);
    const procesosNombre = ['eventos Cercanos', 'eventos Pendientes'];
    const datosCorrectos = resultadoParalelo.map((res, index) => {
        if (res.status === 'fulfilled') {
            return res.value.data;
        } else {
            console.error(`Error al procesar: ${procesosNombre[index]}`, res.reason);
            return null;
        }
    });

    return datosCorrectos;
};

export const registrarObservacion = async (objModificado) => {
    //console.log('WKWKW00:', objModificado)
    try {
        const response = await axios.put(`${URL_BASE_MONITOREO}/comunicaronda`, objModificado, obtenerConfig());
        //console.log('WKWKW01:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error registrar Observacion de Evento');
        throw new Error('Error registrar Observacion de Evento');
    }
};

export const obtenerPersonaXHorario = async (objPost) => {
    //console.log('WWJJ00:', objPost)
    try {
        const response = await axios.post(`${URL_BASE_MONITOREO}/turnotrabajo/personasTurno`, objPost, obtenerConfig());
        //console.log('WWJJ00:', response.data)
        return response.data;
    } catch (error) {
        console.error('Error al obtener Personas');
        throw new Error('Error al obtener Personas');
    }
};

export const subirExcelPuestos = async (event) => {
    console.log('CARGA Ingresando--');
    const token = localStorage.getItem('jwt').replaceAll('"', '');
    const file = event.files[0];
    const formData = new FormData();
    formData.append('file', file);
    try {
        const miResponse = await axios.post(`${URL_BASE_MONITOREO}/puesto/cargaExcel`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                Authorization: 'Bearer ' + token
            }
        });
        console.log('CARGA respuesto--', miResponse.data);
        return miResponse.data;
    } catch (error) {
        throw new Error(error.response?.data || 'Error al conectar con el servidor.');
    }
};

export const getPuestosDinamicos = async (proyectoId) => {
    //console.log('WWJJ00:', objPost)
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/proyectoDina/${proyectoId}`, obtenerConfig());
        //console.log('WWJJ00:', response.data)
        const lstResponse = response.data.map((item) => ({
            id: item.puestoId,
            descripcion: item.sigla + ' - ' + item.nombre,
            sigla: item.sigla
        }));
        return lstResponse;
    } catch (error) {
        console.error('Error al obtener Personas');
        throw new Error('Error al obtener Personas');
    }
};

export const getInfoPuesto = async (puestoId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/${puestoId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al obtener info de Puesto');
        throw new Error('Error al obtener info de Puesto');
    }
};

export const regDatosComPuesto = async (objPut) => {
    //console.log('ZZ00=', objPut)
    try {
        const response = await axios.put(`${URL_BASE_MONITOREO}/puesto`, objPut, obtenerConfig());
        //console.log('ZZ01= ', response.data);
        return response.data;
    } catch (error) {
        console.error('Error al registrar los cambios en Puesto');
        throw new Error('Error al registrar los cambios en Puesto');
    }
};

export const obtienePuestosActivos = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/activos`, obtenerConfig());
        const lstSalida = response.data.map((item) => {
            return {
                puestoId: item.puestoId,
                proyectoNombre: item.proyecto.nombre,
                proyectoSigla: item.proyecto.sigla,
                puestoNombre: item.nombre,
                puestoSigla: item.sigla,
                denominativo: item.codigo,
                telefono: item.telefonos,
                codMarcaRapida: item.codMarcaRapida,
                infoAdicional: item.infoAdicional
            };
        });
        //console.log('ZZ00=', lstSalida);

        return lstSalida;
    } catch (error) {
        console.error('Error al Obtener Puestos Activos');
        throw new Error('Error al Obtener Puestos Activos');
    }
};

export const obtenerPuestoActivosAdm = async (proyectoId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/proyecto/activo/${proyectoId}`, obtenerConfig());
        //console.log('WW0=', response.data)
        return response.data
    } catch (error) {
        console.error('Error al Obtener Puestos Activos del Proyecto');
        throw new Error('Error al Obtener Puestos Activos del Proyecto');
    }
}

export const anulaPuesto = async (puestoId) => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/puesto/anular/${puestoId}`, obtenerConfig());
        //console.log('WW0=', response.data)
        return response.data
    } catch (error) {
        console.error('Error al Anular el Puesto');
        throw new Error('Error al Anular el Puesto');
    }
}
